import React, { useEffect, useState } from "react";
import Header from "./Header";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { IconButton } from "@mui/material";

import AIChat from "../AIChat/AIchat";

const Layout = (props) => {
  const location = useLocation();

  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleVisible = () => {
      // Lalabas ang arrow kapag lumagpas ng 400px ang scroll
      if (window.pageYOffset > 400) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleVisible);

    return () =>
      window.removeEventListener("scroll", handleVisible);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

const hideLayoutElements =
  location.pathname.startsWith("/auction-room") ||
  location.pathname.startsWith("/declarator/room");

  return (
    <>
      <div>
        {!hideLayoutElements && <Header />}

        <Outlet />

        {!hideLayoutElements && (
          <>
            {/* Leon Gallery AI Assistant */}
            <AIChat />

            <Footer />
          </>
        )}
      </div>
    </>
  );
};

export default Layout;